<template>
  <div id="app" :class="{'nav-open': $sidebar.showSidebar}">
    <!-- <RwvHeader /> -->
    <notifications></notifications>
    <router-view></router-view>
    <!-- <RwvFooter /> -->
  </div>
</template>

<script>
import RwvHeader from "@/components/TheHeader";
import RwvFooter from "@/components/TheFooter";

export default {
  name: "App",
  components: {
    RwvHeader,
    RwvFooter
  }
};
</script>

<style lang="scss">
@import '@/styles/_global.scss';
@import '@/styles/_type.scss';

.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

.dir-rtl {
  direction: rtl;
  text-align: right;
}
</style>
